import {connect} from 'react-redux';
import {useState} from 'react'
import {push} from 'connected-react-router'
import {
    Header, 
    Paragraph,
    Button,
    ErrorMark
} from '../../components/RegularComponents'
import CheckboxForm from '../../components/CheckBoxForm'
import Navigation from '../Navigation'
import TopNavigationBar from '../TopNavigationBar'
import {replaceUrlParams} from '../../app/utils'
import {confirmBeforePaymentSelect} from '../../redux/selector/confirmBeforePaymentSelector'
import { ERROR_STRING } from '../../app/errors';

const ConfirmBeforePayment = (props) => {
    const {applicationType, applicationMode} = props.match.params
    const {dispatch, confirmBeforePayment} = props
    const [confirmCheck, setConfirmCheck] = useState(false)
    const [showValidationError,setShowValidationError] = useState(false)

    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
                <TopNavigationBar {...props} />

                <div className="row bottomMarginMedium">
                    <div className="col-8">
                        <Header 
                            id="confirm-before-payment-header" 
                            header={confirmBeforePayment.header} />
                        <Paragraph 
                            id="confirm-before-payment-text"
                            text={confirmBeforePayment.text} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-8">
                        <CheckboxForm 
                            id="confirm-before-start-checkbox"
                            checked={confirmCheck}
                            value={confirmCheck}
                            labelText="Yes, I confirm"
                            onCheckBoxChange={(val) => {
                                setShowValidationError(false)
                                setConfirmCheck(val)
                            }}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className={"col-lg-4" + (showValidationError ? " has-error" : "")}>
                        <Button
                            id="cofirm-before-payment-continue-button"
                            buttonType={"regular_primary"}
                            text={"Pay and submit application"}
                            onClick={() => {

                                if(!confirmCheck) { 
                                    setShowValidationError(true)
                                    return
                                }

                                setShowValidationError(false)

                                dispatch(push(replaceUrlParams(confirmBeforePayment.navigation.next,applicationType, applicationMode)))
                            }}
                        />
                        {showValidationError && ErrorMark()}
                        {showValidationError && <div className="ns-error-message">
                            <span className="ns-visually-hidden">Error:</span>
                            {ERROR_STRING.CONFIRM_BEFORE_PAYMENT_CONFIRMATION_NOT_CHECKED}
                        </div>}
                    </div>
                </div>
            </div>
        </>
    )
}

export default connect(confirmBeforePaymentSelect)(ConfirmBeforePayment)
